import React from 'react';
import Modal from './Modal';
import {useModelContext} from './modalContext';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';
import {BaseButton, NoStyleButton} from './Button';

import Img from './Img';
import useForm from '../utils/useForm';
import {postRecord} from '../api/voteApi';

import img_close_btn from '../assets/img/pcpp01-2.png'
import img_star_s from '../assets/img/pcpp01-3.png'
import img_star_p from '../assets/img/pcpp02-3.png'
import img_title_s from '../assets/img/title1.png'
import img_title_p from '../assets/img/title2.png'

const ModalStyles = styled(Modal)`
  background-color: rgba(0, 0, 0, .5);
  padding: 2rem;
  justify-content: center;
`;

const ModalBoxStyles = styled.div`
  width: 100%;
  max-width: 60rem;
  max-height: calc(100vh - 4rem);
  overflow: auto;
  margin-right: auto;
  margin-left: auto;
  padding: 2rem;
  background-color: var(--bg);
  position: relative;
  border-radius: 1.6rem;
  border: 1px solid var(--black);
  .theme-secondary & {
    --bg: var(--secondary);
  }

  .theme-primary & {
    --bg: var(--other);
  }

  > .title {
    width: 88%;
  }

  .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
    max-width: 4.4rem;
  }
}

@media (min-width: ${breakPoint.min}) {
  > .title {
    font-size: 3.2rem;
    margin-bottom: 3rem;

  }
}

@media (max-width: ${breakPoint.smMax}) {
  > .title {
    font-size: 2.1rem;
  }

  .close {
    max-width: 3.4rem;
  }
}
`;

const FormStyles = styled.div`
  background-color: white;
  overflow: hidden;
  padding: 4rem;
  form {
    max-width: 44rem;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  label {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    width: 100%;

    &:not(.check) {
      white-space: nowrap;

      &::before {
        content: '';
        display: block;
        width: 2rem;
        height: 2rem;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        margin-right: .4rem;
        flex-shrink: 0;

        .theme-secondary & {
          background-image: url(${img_star_s});
        }
        .theme-primary & {
          background-image: url(${img_star_p});
        }
      }

      input {
        flex: 1 1 auto;
        margin: 0 0 0 1rem;
        padding: .6rem 1rem;
      }
    }

    &.check {
      align-items: flex-start;

      input {
        margin-top: 1.4rem;
        margin-right: 1rem;
      }
    }
  }

  .submit {
    max-width: 18rem;
    margin-right: auto;
    margin-left: auto;
  }

  @media (max-width: ${breakPoint.max}) {
    border-radius: 1.1rem;
    padding: 2rem;
    label {
      margin-bottom: 1.5rem;

      &:not(.check) {
        input {
          width: 100%;
        }
      }

      &.check {
        input {
          margin-top: .5rem;
        }
      }
    }

    .submit {
      max-width: 14rem;
    }
  }
`;

const VoteModal = ({className, getRecordApi, doApi, voteType, ...props}) => {
    const {voteId, handleShowModal} = useModelContext();
    const {values, updateValue, resetValue} = useForm({
        name: '',
        phone: '',
        email: '',
        address: '',
    });

    const postRecordApi = async (e) => {
        e.preventDefault();
        const data = {
            ...values,
            vote_type: voteType,
            vote: voteId,
        }
        let resp = await postRecord(data);
        if (resp) {
            alert('別忘了【最愛封面票選】&【社群風格家庭】都要投票喔！\n' +
                '完成兩項投票即可抽風格好禮，總價值超過四萬元！\n');
            resetValue();
            handleShowModal(false);
            getRecordApi();
        }
    }


    return (
        <ModalStyles className={className}>
            <ModalBoxStyles className="animate__animated animate__fadeInUp animate__faster">
                <Img src={voteType === 1 ? img_title_s : img_title_p} wrapProps={{className: 'title'}} />
                <NoStyleButton as="button" onClick={() => handleShowModal(false)} className="close">
                    <Img src={img_close_btn} wrapProps={{className: 'close-img'}}/>
                </NoStyleButton>
                <FormStyles>
                    <form onSubmit={postRecordApi}>
                        <label htmlFor="name">
                            姓名:
                            <input
                                type="text"
                                name="name"
                                id="name"
                                value={values.name}
                                onChange={updateValue}
                                required
                            />
                        </label>
                        <label htmlFor="phone">
                            聯絡電話:
                            <input
                                type="text"
                                name="phone"
                                id="phone"
                                value={values.phone}
                                onChange={updateValue}
                                required
                            />
                        </label>
                        <label htmlFor="email">
                            E-mail:
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={values.email}
                                onChange={updateValue}
                                required
                            />
                        </label>
                        <label htmlFor="address">
                            寄送地址:
                            <input
                                type="text"
                                name="address"
                                id="address"
                                value={values.address}
                                onChange={updateValue}
                                required
                            />
                        </label>
                        <label className="check" htmlFor="check">
                            <input type="checkbox" name="check" id="check" required/>
                            我已詳閱活動說明及注意事項，並同意將個人資料提供給活動抽獎使用，以利兌獎。
                        </label>
                        <BaseButton as="button" className={"submit"}>送出投票</BaseButton>
                    </form>
                </FormStyles>
            </ModalBoxStyles>
        </ModalStyles>
    )
};

export default VoteModal;
